var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513.56 496.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 97.06,
    height: 98.1,
    x: 55.26,
    y: 20.45,
    fill: "#ffedc5",
    rx: 13,
    transform: "rotate(71.28 103.785 69.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114.32,
    height: 114.32,
    x: 46.63,
    y: 12.34,
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 13,
    transform: "rotate(71.28 103.785 69.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8bed3",
    d: "M220.74,317.94c-1.32,3.6,7.41,12.34,11.65,16.58,3.17,3.19,6.06,5.49,6.7,9.53s-1.24,7.13-2.12,8.83c-6.52,12.6-5,31.05,1.42,41.64.56.94,5.31,8.67,9.17,7.77s4.81-9.93,4.94-11.29c.52-5.48-1-7.45-1.05-12-.06-6.91,3.4-11.59,5.64-15.53,5.34-9.4,11.21-27.76,5.3-38.12C254.11,310.84,222.85,312.14,220.74,317.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccd8",
    d: "M252.61,388.56c-5.65,5.33-11.87,4.16-16.17,2.15a32.36,32.36,0,0,0,1.95,3.81c.56.93,5.32,8.67,9.17,7.76s4.82-9.93,4.95-11.29A23.72,23.72,0,0,0,252.61,388.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M242 392.33c.66 1.68 1.12 3.36 1.66 5a29.73 29.73 0 001.88 4.86 6.63 6.63 0 01-1.76-2.07 13 13 0 01-1.07-2.49 16.82 16.82 0 01-.59-2.62A11.54 11.54 0 01242 392.33zM248.51 391.34c-.06 1.8-.14 3.53-.13 5.26 0 .87 0 1.74.05 2.61s.09 1.75.08 2.66a12.1 12.1 0 01-1.13-5.27 13.48 13.48 0 01.26-2.69A9.29 9.29 0 01248.51 391.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88a4b7",
    d: "M262.39,325.35c-8.28-14.51-39.54-13.21-41.65-7.41-1,2.78,3.94,8.61,8.2,13.08h35.45A18.45,18.45,0,0,0,262.39,325.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8bed3",
    d: "M152.38,315.72c-3,3.06-3.27,6.43,1.77,41.3a157.09,157.09,0,0,0,12.7,40.58c.82,1.71,2.74,5.48,6.71,7.06,2.09.84,5.66,1.42,7.76-.35,2.66-2.24,1.7-7.12.71-12.71-1.36-7.73-2.2-15.55-3.53-23.29-1.26-7.37-3.36-19.63-1.76-33.88,1.33-11.86,4.13-15.37,1.41-19.06C173.7,309.34,159.05,309,152.38,315.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccd8",
    d: "M182.2,392.55c-6,5.59-12.63,3.87-16.91,1.65h0c.49,1.13,1,2.27,1.56,3.4.82,1.71,2.74,5.48,6.71,7.06,2.09.84,5.65,1.42,7.76-.35C183.83,402.2,183.11,397.74,182.2,392.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M175 405.11a8.39 8.39 0 01-1.44-1.92 9.64 9.64 0 01-.95-2.21 6.61 6.61 0 01-.3-2.43 3.36 3.36 0 011-2.25 5.23 5.23 0 00-.17 2.24 11.78 11.78 0 00.48 2.16C173.93 402.15 174.49 403.57 175 405.11zM180.67 404.75a7 7 0 01-1.77-1.9 9.3 9.3 0 01-1.12-2.36 8.23 8.23 0 01-.36-2.61 6.3 6.3 0 01.55-2.54 24.22 24.22 0 00.23 2.49 14.2 14.2 0 00.54 2.36A26.73 26.73 0 00180.67 404.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88a4b7",
    d: "M152.38,315.72c-2,2-2.77,4.16-1.65,15.3h26.46c1.4-9.16,3.4-12.34,1-15.65C173.7,309.34,159.05,309,152.38,315.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.94,
    height: 170.76,
    x: 421.97,
    y: 325.02,
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fda01f",
    d: "M438.91,345.91c-1.26,1.25-2.62,2.71-4.17,4.4-2.72,2.94-5,5.94-12,16.94l-.77,1.21V445l2.53-1.89a88,88,0,0,0,14.41-13.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 31.82,
    x: 0.5,
    y: 293.19,
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.94,
    height: 170.76,
    x: 73.97,
    y: 325.02,
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.94,
    height: 6,
    x: 73.97,
    y: 325.02,
    fill: "#fda01f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.94,
    height: 170.76,
    x: 247.97,
    y: 325.02,
    fill: "#ffcd52"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.94,
    height: 6,
    x: 247.97,
    y: 325.02,
    fill: "#fda01f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fda01f",
    d: "M74 346.21a19 19 0 018.36-2.69 15.32 15.32 0 018.58 1.75 26.74 26.74 0 00-8.51-.75A41 41 0 0074 346.21zM74 352.88a19 19 0 018.36-2.69 15.32 15.32 0 018.58 1.75 26.74 26.74 0 00-8.51-.75A41 41 0 0074 352.88zM74 396.21a19 19 0 018.36-2.69 15.32 15.32 0 018.58 1.75 26.74 26.74 0 00-8.51-.75A41 41 0 0074 396.21zM74 402.88a19 19 0 018.36-2.69 15.32 15.32 0 018.58 1.75 26.74 26.74 0 00-8.51-.75A41 41 0 0074 402.88zM74 446.21a19 19 0 018.36-2.69 15.32 15.32 0 018.58 1.75 26.74 26.74 0 00-8.51-.75A41 41 0 0074 446.21zM74 452.88a19 19 0 018.36-2.69 15.32 15.32 0 018.58 1.75 26.74 26.74 0 00-8.51-.75A41 41 0 0074 452.88zM74 486.83a18.74 18.74 0 018.36-2.69 15.23 15.23 0 018.58 1.75 26.75 26.75 0 00-8.51-.76A41.06 41.06 0 0074 486.83zM74 493.5a18.74 18.74 0 018.36-2.69 15.23 15.23 0 018.58 1.75 26.75 26.75 0 00-8.51-.76A41.06 41.06 0 0074 493.5zM422 344.7a18.51 18.51 0 018.43-2.44 15.16 15.16 0 018.51 2.08 25.86 25.86 0 00-8.47-1.08A39.73 39.73 0 00422 344.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d86c1d",
    d: "M422,351.38a18.65,18.65,0,0,1,8.43-2.45,15.18,15.18,0,0,1,8.51,2.08,26.41,26.41,0,0,0-8.47-1.08A39,39,0,0,0,422,351.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fda01f",
    d: "M422 444.7a18.51 18.51 0 018.43-2.44 15.16 15.16 0 018.51 2.08 25.86 25.86 0 00-8.47-1.08A39.73 39.73 0 00422 444.7zM422 451.38a18.65 18.65 0 018.43-2.45 15.18 15.18 0 018.51 2.08 26.41 26.41 0 00-8.47-1.08A39 39 0 00422 451.38zM422 486.83a18.64 18.64 0 018.43-2.44 15.16 15.16 0 018.51 2.08 26.41 26.41 0 00-8.47-1.08A39.73 39.73 0 00422 486.83zM422 493.51a18.51 18.51 0 018.43-2.44 15.26 15.26 0 018.51 2.07 26.12 26.12 0 00-8.47-1.07A39 39 0 00422 493.51zM248 373.49a18.51 18.51 0 018.43-2.44 15.16 15.16 0 018.51 2.08 25.86 25.86 0 00-8.47-1.08A39.73 39.73 0 00248 373.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d86c1d",
    d: "M248,380.16a18.51,18.51,0,0,1,8.43-2.44,15.16,15.16,0,0,1,8.51,2.08,25.86,25.86,0,0,0-8.47-1.08A39.73,39.73,0,0,0,248,380.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fda01f",
    d: "M248 423.49a18.51 18.51 0 018.43-2.44 15.16 15.16 0 018.51 2.08 25.86 25.86 0 00-8.47-1.08A39.73 39.73 0 00248 423.49zM248 430.16a18.51 18.51 0 018.43-2.44 15.16 15.16 0 018.51 2.08 25.86 25.86 0 00-8.47-1.08A39.73 39.73 0 00248 430.16zM248 473.49a18.51 18.51 0 018.43-2.44 15.16 15.16 0 018.51 2.08 25.86 25.86 0 00-8.47-1.08A39.73 39.73 0 00248 473.49zM248 480.16a18.51 18.51 0 018.43-2.44 15.16 15.16 0 018.51 2.08 25.86 25.86 0 00-8.47-1.08A39.73 39.73 0 00248 480.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M83.64 196.36a22.28 22.28 0 014.08.62 34.46 34.46 0 013.82 1.16 1.69 1.69 0 011 2.17A1.63 1.63 0 0192 201l-.27.22a43 43 0 01-7.11 4.68l0-2.94a33.55 33.55 0 012.78 2.69 21.6 21.6 0 012.45 3.16 22 22 0 01-3.8-1.24 31.86 31.86 0 01-3.47-1.7 1.63 1.63 0 01-.63-2.24 1.7 1.7 0 01.38-.46l.29-.23a43 43 0 017.08-4.72l.22 3.12a35.49 35.49 0 01-3.3-2.24A22.62 22.62 0 0183.64 196.36zM97.88 219.8a15.69 15.69 0 013.41.3 23.5 23.5 0 013.15.83 1.68 1.68 0 011 2.12 1.71 1.71 0 01-.5.73l-.33.28a28.74 28.74 0 01-5.77 3.79l0-2.94a21.53 21.53 0 012.19 2.28 14.84 14.84 0 011.87 2.74 15.09 15.09 0 01-3.21-.82 22.85 22.85 0 01-2.89-1.29 1.61 1.61 0 01-.67-2.18 1.53 1.53 0 01.37-.46l.34-.3a28.79 28.79 0 015.75-3.83l.22 3.13a21.88 21.88 0 01-2.63-1.93A15.41 15.41 0 0197.88 219.8zM101.56 178.37c1 .18 2 .41 3 .67s2 .53 2.92.84q2.89.92 5.68 2a1.74 1.74 0 011 2.25 1.71 1.71 0 01-.56.73l-.19.14a98.3 98.3 0 01-10.8 7.13l0-2.94c1.51 1.22 3 2.49 4.41 3.83a47.44 47.44 0 014.08 4.29 46.39 46.39 0 01-5.43-2.37c-1.74-.88-3.44-1.84-5.1-2.84a1.7 1.7 0 01-.57-2.33 1.69 1.69 0 01.42-.46l.19-.15A100.74 100.74 0 01111.39 182l.22 3.13Q109 183.7 106.45 182c-.84-.56-1.66-1.15-2.49-1.75S102.34 179.06 101.56 178.37zM105.35 137.69c2.34.33 4.63.79 6.89 1.32 1.14.24 2.27.53 3.39.82s2.25.58 3.37.9a1.31 1.31 0 01.91 1.62 1.23 1.23 0 01-.36.6l-.08.08q-5.48 5.15-11.35 9.82l-.26-2.19c1 .56 1.94 1.15 2.9 1.74s1.92 1.18 2.86 1.8c1.89 1.22 3.76 2.49 5.56 3.89-2.17-.68-4.29-1.49-6.37-2.35-1-.42-2.08-.86-3.11-1.32s-2.06-.91-3.07-1.39a1.3 1.3 0 01-.62-1.73 1.21 1.21 0 01.28-.38l.08-.08q5.46-5.16 11.33-9.85l.46 2.3c-1.08-.4-2.17-.82-3.24-1.26s-2.16-.86-3.23-1.34C109.55 139.78 107.43 138.8 105.35 137.69zM135.6 175.41a54.78 54.78 0 015.64.91c1.86.37 3.69.82 5.51 1.31a1.32 1.32 0 01.93 1.61 1.36 1.36 0 01-.36.6l-.1.09a116.1 116.1 0 01-9.21 8l-.25-2.19c1.56.94 3.12 1.9 4.62 2.94a53.82 53.82 0 014.44 3.31 52.81 52.81 0 01-5.24-1.76c-1.72-.64-3.4-1.37-5.06-2.12a1.3 1.3 0 01-.64-1.7 1.39 1.39 0 01.28-.39l.1-.1a116.07 116.07 0 019.19-8l.46 2.3c-1.75-.68-3.5-1.39-5.22-2.19A53.05 53.05 0 01135.6 175.41zM132.56 102.15c3.44.84 6.84 1.76 10.24 2.72s6.78 2 10.14 3a.87.87 0 01.58 1.1.78.78 0 01-.24.39l0 0c-2.82 2.56-5.69 5-8.54 7.56l-4.33 3.71c-1.44 1.24-2.91 2.45-4.37 3.67l-.17-1.45q4.5 2.46 8.94 5c3 1.7 5.9 3.44 8.8 5.26-3.15-1.35-6.26-2.77-9.34-4.23s-6.16-3-9.21-4.48a.87.87 0 01-.39-1.17.83.83 0 01.19-.26l0 0c1.42-1.27 2.81-2.55 4.25-3.8l4.29-3.76c2.88-2.48 5.75-5 8.68-7.4l.31 1.52c-3.34-1.14-6.65-2.33-10-3.56S135.83 103.51 132.56 102.15z",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.79,
    x2: 5.4,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.53,
    x2: 12.69,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.81,
    x2: 18.81,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.97,
    x2: 23.97,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.7,
    x2: 29.7,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.64,
    x2: 37.8,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.03,
    x2: 42.39,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.78,
    x2: 47.25,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.1,
    x2: 53.55,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.3,
    x2: 60.66,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.14,
    x2: 67.5,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.29,
    x2: 74.7,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.1,
    x2: 81,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.56,
    x2: 88.56,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.84,
    x2: 96.84,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.79,
    x2: 103.79,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.32,
    x2: 111.51,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.78,
    x2: 120.06,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.25,
    x2: 126.99,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.74,
    x2: 133.74,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.49,
    x2: 140.04,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.79,
    x2: 146.4,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.53,
    x2: 153.69,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.81,
    x2: 159.81,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.97,
    x2: 164.97,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.7,
    x2: 170.7,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.64,
    x2: 178.8,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.03,
    x2: 183.39,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.78,
    x2: 188.25,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.1,
    x2: 194.55,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.3,
    x2: 201.66,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.14,
    x2: 208.5,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.29,
    x2: 215.7,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.1,
    x2: 222,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.56,
    x2: 229.56,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.84,
    x2: 237.84,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.79,
    x2: 244.79,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.32,
    x2: 252.51,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.78,
    x2: 261.06,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.25,
    x2: 267.99,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.74,
    x2: 274.74,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.49,
    x2: 281.04,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.79,
    x2: 288.4,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.53,
    x2: 295.69,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.81,
    x2: 301.81,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.97,
    x2: 306.97,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.7,
    x2: 312.7,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.64,
    x2: 320.8,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.03,
    x2: 325.39,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.78,
    x2: 330.25,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.1,
    x2: 336.55,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 343.3,
    x2: 343.66,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350.14,
    x2: 350.5,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.29,
    x2: 357.7,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.1,
    x2: 364,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.56,
    x2: 371.56,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 379.84,
    x2: 379.84,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.79,
    x2: 386.79,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 395.32,
    x2: 394.51,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.78,
    x2: 403.06,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.25,
    x2: 409.99,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.74,
    x2: 416.74,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 423.49,
    x2: 423.04,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.79,
    x2: 429.4,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 437.53,
    x2: 436.69,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442.81,
    x2: 442.81,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447.97,
    x2: 447.97,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.7,
    x2: 453.7,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 459.64,
    x2: 461.8,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.03,
    x2: 466.39,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472.78,
    x2: 471.25,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 477.1,
    x2: 477.55,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 484.3,
    x2: 484.66,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 491.14,
    x2: 491.5,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 497.29,
    x2: 498.7,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 504.1,
    x2: 505,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512.56,
    x2: 512.56,
    y1: 293.19,
    y2: 325.02,
    fill: "none",
    stroke: "#fda01f",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8bed3",
    d: "M61,280.54s-4.23,5.65-4.35,6.59c0,0,4.12-1.76,4.47-1.17,0,0-3.82,6.17-3.82,7.23l256.55.08c4.24.61,15.13,2.81,19.27,5.16,6.55,3.71,9.59,9.63,11.65,13.76,2.17,4.38,5.51,12.75,5.29,28.94-.18,12.95-2.4,13.56-4.23,30.71-1.38,12.83-2.36,22.65,0,34.94,1.5,7.86,3.21,16.79,9.88,25.76,2.68,3.62,14,17.83,32.12,19.42,15.16,1.33,26.25-7,36.7-14.83,21.25-15.94,29.26-36.32,35.65-52.59,10.26-26.12,5.82-35.44,4.59-37.76-3.07-5.76-9.82-12.59-16.94-12-4.53.37-7.6,3.61-13.06,9.53-2.72,2.94-5,5.94-12,16.94-5.61,8.87-8.14,13.3-13.42,19.41-5.44,6.31-7.87,7.51-10.23,7.77-5.89.64-10.77-4.62-12.71-6.71-2.91-3.14-6-8-8.11-19.41-1.93-10.48-.66-13.68-1.42-24.35s-1.47-20.86-6.7-30.36c-7.16-13-29-22-33.65-24.23,2.74-7.81,8.15-26.68,2.12-48.94-1.93-7.12-11.55-38.63-40-49.41-16.78-6.36-31.54-1.94-51.3,3-27.93,7.06-46.62,21.29-60.7,32.24-15.43,12-23.89,24.48-31.06,33.18,1.65-8-6.12-31.77-6.12-31.77-7.06,4.71-19.06,24-19.06,24-4.22-2.64-9.63-5.35-20.23-6.83-10-1.39-14.69-.66-19.41.61L76.5,221.72c-3.29,5.65-1.18,24.71-1.18,24.71A35.4,35.4,0,0,0,61,280.54"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M148.15,274.43c1.34,1.19,2.64,2.41,4,3.61s2.61,2.45,3.92,3.68a.33.33,0,0,1,0,.47.32.32,0,0,1-.34.09h0l-4.43-1.39-4.42-1.44.45-.78c1.43,1.29,2.82,2.61,4.15,4a28.73,28.73,0,0,1,1.89,2.22,11.15,11.15,0,0,1,.83,1.24,5.14,5.14,0,0,1,.33.75,1.27,1.27,0,0,1-.06,1.07.42.42,0,0,1-.49.21h0c-1.26-.34-2.5-.69-3.74-1.09-.61-.21-1.23-.41-1.85-.68a4.06,4.06,0,0,1-1-.55l-.14-.15-.06-.1-.13-.21-.26-.4v0a.37.37,0,0,1,.11-.51.38.38,0,0,1,.41,0c1.7,1.14,3.37,2.3,5,3.52.81.63,1.62,1.25,2.4,1.91a13,13,0,0,1,2.15,2.17,15.6,15.6,0,0,0-2.31-2c-.82-.6-1.66-1.16-2.51-1.73-1.69-1.12-3.41-2.22-5.14-3.28l.51-.52.27.4.14.2.07.1,0,0a4.19,4.19,0,0,0,.73.35c.58.22,1.18.43,1.79.61,1.22.38,2.47.71,3.7,1l-.5.2a.71.71,0,0,0,0-.32,2.76,2.76,0,0,0-.26-.56,11.18,11.18,0,0,0-.77-1.12c-.57-.73-1.21-1.43-1.86-2.12-1.28-1.38-2.64-2.72-4-4h0a.46.46,0,0,1,0-.65.47.47,0,0,1,.49-.12l4.4,1.5,4.38,1.56-.35.56c-1.24-1.29-2.5-2.56-3.73-3.86S149.36,275.75,148.15,274.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccd8",
    d: "M80.52 244.34V233l5.16 9.74S82.28 242.44 80.52 244.34zM140.38 247.13L147 236.57v13.15S145.5 245.69 140.38 247.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M146.21,260a14.68,14.68,0,0,1,4.15,3,18,18,0,0,1,3.1,4.12,19.51,19.51,0,0,1,2.28,7.36c.06.85.06,1.71,0,2.56a41.14,41.14,0,0,0-1.23-4.89,25,25,0,0,0-2-4.54,24.68,24.68,0,0,0-2.8-4.09A25.29,25.29,0,0,0,146.21,260Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#475259",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M77.56 275.84s-3.26-3.88-7.24-4.5M110 276.54a13.8 13.8 0 0112.79-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M103,283.37a49.16,49.16,0,0,1,9.29-4.2,57.67,57.67,0,0,1,9.94-2.43c1.69-.29,3.39-.4,5.09-.56l2.57-.06c.42,0,.85,0,1.28,0l1.28.07a45.66,45.66,0,0,1,10.08,1.52c-.84-.09-1.69-.2-2.52-.31a23.81,23.81,0,0,0-2.53-.25l-2.52-.18c-.84,0-1.69,0-2.53,0-1.68-.05-3.36.11-5,.19s-3.35.3-5,.6a75.6,75.6,0,0,0-9.85,2.17l-2.42.74-2.39.84C106.09,282,104.52,282.68,103,283.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M105.35 284.66a61.4 61.4 0 017.82-2.52 64.77 64.77 0 018.08-1.57 46.3 46.3 0 018.24-.38 26.32 26.32 0 018.07 1.56c-.68-.12-1.35-.24-2-.38s-1.35-.15-2-.24a19.58 19.58 0 00-2-.14c-.67 0-1.35-.07-2 0l-2 .05-2 .13c-1.35.1-2.7.24-4 .42-2.7.32-5.37.82-8 1.33-1.34.25-2.67.54-4 .85S106.69 284.34 105.35 284.66zM104.74 286.34a66.91 66.91 0 017-1.31 70.9 70.9 0 017.14-.63 44.23 44.23 0 017.18.27 22.79 22.79 0 013.54.76 7.52 7.52 0 013.11 1.79 8.2 8.2 0 00-3.24-1.32 22.56 22.56 0 00-3.48-.46 69.64 69.64 0 00-7.08 0c-2.36.07-4.72.24-7.09.39zM77.5 281.37c-1.55-.69-3.11-1.34-4.71-1.89l-2.39-.84L68 277.9a75.74 75.74 0 00-9.86-2.17c-1.66-.3-3.33-.42-5-.6s-3.36-.24-5-.19c-.84 0-1.68 0-2.53 0l-2.52.18a23.37 23.37 0 00-2.52.25c-.84.11-1.68.22-2.53.31a45.75 45.75 0 0110.09-1.52l1.28-.07c.42 0 .85 0 1.28 0l2.56.06c1.7.16 3.41.27 5.09.56a57.23 57.23 0 019.94 2.43A49.16 49.16 0 0177.5 281.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M75.12 282.66c-1.33-.32-2.66-.65-4-.92s-2.66-.6-4-.85c-2.67-.51-5.34-1-8-1.33q-2-.27-4.05-.42L53 279 51 279c-.68 0-1.35 0-2 0a19.39 19.39 0 00-2 .14c-.67.09-1.36.1-2 .24s-1.33.26-2 .38A26.38 26.38 0 0151 278.19a46.3 46.3 0 018.24.38 64.77 64.77 0 018.08 1.57A60.89 60.89 0 0175.12 282.66zM75.74 284.34l-7.12-.55c-2.36-.15-4.73-.32-7.09-.39a69.46 69.46 0 00-7.07 0 22.85 22.85 0 00-3.49.46 8.16 8.16 0 00-3.23 1.32 7.42 7.42 0 013.1-1.79 22.79 22.79 0 013.54-.76 44.35 44.35 0 017.19-.27 70.7 70.7 0 017.13.63A67.1 67.1 0 0175.74 284.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccd8",
    d: "M88.77,284c-1.8-1.21-1.42-2.35-3.45-3.53-1.76-1-2.77-.58-3.44-1.59-1-1.5.3-3.89.53-4.32s1.45-2.7,3.71-3.09c1.58-.28,2,.67,4.5,1.06,1.31.2,1.4,0,5.12-.27,5-.32,5.77,0,6.26.44a4,4,0,0,1,1.32,4c-.65,2.05-3.25,1.52-5.64,4.33-1.53,1.8-1,2.68-2.38,3.53C93.45,285.63,90.61,285.2,88.77,284Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M91.09 292.07a7.93 7.93 0 01-.53-3.56 9 9 0 01.86-3.49 15.19 15.19 0 01.14 3.55A21.73 21.73 0 0191.09 292.07zM212.38 261.84a39.58 39.58 0 013.09 4.9 45.68 45.68 0 012.47 5.25 31.72 31.72 0 011.67 5.58 15.11 15.11 0 01.19 5.8 22.57 22.57 0 00-1-5.62 51.07 51.07 0 00-1.84-5.39c-.69-1.78-1.45-3.53-2.23-5.28zM242.85 268.47a26.22 26.22 0 01-.1-9.39 22.09 22.09 0 011.31-4.57 13.72 13.72 0 012.56-4 25.36 25.36 0 00-1.83 4.24 38.19 38.19 0 00-1.06 4.47c-.26 1.51-.43 3-.57 4.57S242.91 266.9 242.85 268.47zM249 270.31a108.79 108.79 0 013.53-10.84c1.34-3.56 2.9-7 4.58-10.45a71.07 71.07 0 015.87-9.81 30.66 30.66 0 018-8.08c-.7.64-1.41 1.27-2.12 1.89s-1.27 1.4-1.9 2.1-1.17 1.48-1.75 2.21a26.72 26.72 0 00-1.62 2.32c-1.06 1.55-2 3.18-3 4.8s-1.81 3.31-2.63 5c-1.73 3.35-3.28 6.81-4.76 10.29q-1.12 2.61-2.16 5.25C250.33 266.76 249.65 268.53 249 270.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.8,297.49l2.7-4c.88-1.34,1.78-2.67,2.6-4.05s1.65-2.75,2.36-4.18a30.56,30.56,0,0,0,1.86-4.44,15.7,15.7,0,0,1-1.14,4.76,29,29,0,0,1-2.22,4.38A36.27,36.27,0,0,1,295.8,297.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M187.29 245.22A87.15 87.15 0 01201 230.54a100.64 100.64 0 0116.39-11.62l2.18-1.25c.74-.39 1.51-.75 2.26-1.12 1.51-.73 3-1.51 4.53-2.18a91.24 91.24 0 019.41-3.55l2.4-.75c.8-.25 1.6-.52 2.42-.69l4.9-1.12a43.35 43.35 0 014.95-.84l5-.66A114.21 114.21 0 00236 211.55c-3.18 1-6.21 2.38-9.29 3.65-1.51.68-3 1.47-4.47 2.2-.74.38-1.49.73-2.22 1.13l-2.16 1.26c-2.92 1.58-5.68 3.44-8.46 5.27l-4 2.95c-1.32 1-2.6 2.08-3.91 3.11s-2.51 2.18-3.78 3.27-2.43 2.28-3.62 3.44A87.46 87.46 0 00187.29 245.22zM315.8 213.29a45.67 45.67 0 014.74 7.63 53.22 53.22 0 013.34 8.38 43.64 43.64 0 011.76 8.85 36.46 36.46 0 01-.2 9c0-.75 0-1.49 0-2.24v-1.11l-.09-1.12-.15-2.22-.3-2.2a57.91 57.91 0 00-2-8.65 73.09 73.09 0 00-3.07-8.34c-.6-1.36-1.23-2.71-1.92-4S316.55 214.58 315.8 213.29zM161.74 263.49a9.91 9.91 0 012.43 2.23 17.41 17.41 0 011.82 2.77 16.74 16.74 0 011.83 6.31c-.48-1-.89-2-1.34-3s-.9-1.94-1.38-2.89A40.67 40.67 0 00161.74 263.49zM170.74 284.85c1.79 1.2 3.47 2.47 5.2 3.68.85.62 1.72 1.2 2.59 1.8l2.68 1.74a16 16 0 01-5.85-2.72 24.87 24.87 0 01-2.5-2.06A16.42 16.42 0 01170.74 284.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccd8",
    d: "M455.28,396.46s0,0,0,0h0a57.83,57.83,0,0,0-27.39-43.16,65.76,65.76,0,0,1,6.84-9c5.46-5.92,8.54-9.16,13.06-9.53,7.12-.59,13.88,6.24,16.94,12,1.24,2.32,5.68,11.64-4.58,37.76-1.48,3.79-3.06,7.79-4.87,11.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M356.74,396.46a83.79,83.79,0,0,0,2.57,9.34,77.24,77.24,0,0,0,3.58,9c2.76,5.78,6.25,11.34,11.14,15.47a25,25,0,0,0,17.55,6.18c.8,0,1.59-.14,2.39-.21.39,0,.8-.06,1.19-.13l1.18-.24c.78-.17,1.58-.29,2.35-.5l2.31-.7c.38-.12.77-.22,1.15-.35l1.13-.44,2.25-.88c1.47-.66,2.91-1.39,4.38-2.07a42.1,42.1,0,0,1-18.29,6.29,25.48,25.48,0,0,1-9.72-1.31,26.61,26.61,0,0,1-8.52-4.88,37.15,37.15,0,0,1-6.47-7.36,54,54,0,0,1-4.72-8.55A73.77,73.77,0,0,1,356.74,396.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8bed3",
    d: "M171.32,282.19a15.69,15.69,0,0,1,8.24,6.12c.83,1.25,1.3,2.47,2.35,6.12,2.08,7.16,2.83,11.06,2.83,11.06,1.79,9.36,2.72,14.24,3.53,22.11,1.52,15-.08,14.92,1.17,28.24,1.43,15.21,4.38,24.34,5.65,28,4.63,13.29,9.35,17.87,12.47,20.23,1.71,1.3,8.53,6.45,12.94,4,3.37-1.87,3.64-7.23,3.77-9.64.37-7.31-2.76-10.89-5.18-18.12-2.23-6.66-2.27-11.73-2.35-21.88-.09-11,1.57-11.58,2.11-25.41.25-6.11,0-11.44-.47-22.12-.76-17.12-1.79-21.11-3.06-24.47a45.77,45.77,0,0,0-7.52-12.94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M217 293.19c-.47-1.78-.94-3.55-1.56-5.25a53.65 53.65 0 00-2.16-5 80 80 0 00-5.48-9.46 33.63 33.63 0 018.38 14.21A23.37 23.37 0 01217 293.19zM171.32 282.19a12.68 12.68 0 017 3.78 11.59 11.59 0 012.28 3.37 16.77 16.77 0 011 3.89c-.57-1.2-1.07-2.43-1.67-3.55a11.61 11.61 0 00-1-1.57 15.55 15.55 0 00-1.24-1.45A22 22 0 00171.32 282.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccd8",
    d: "M198.84,393.22s14,10.08,24.31-2.67a20.24,20.24,0,0,1,1.11,7.88c-.12,2.41-.39,7.77-3.76,9.64-4.41,2.45-11.23-2.7-12.94-4-2.2-1.66-5.19-4.43-8.39-10.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M207.12 396.66c1.63 2.15 3.12 4.34 4.71 6.46.78 1.06 1.61 2.08 2.48 3.07a10.38 10.38 0 003 2.51 7.19 7.19 0 01-3.55-2 21.11 21.11 0 01-2.73-3A29 29 0 01207.12 396.66zM217.47 395.34c.23 2.28.36 4.52.68 6.71a19.11 19.11 0 00.7 3.21 6.12 6.12 0 001.65 2.81 4.67 4.67 0 01-2.38-2.52 12 12 0 01-1-3.36 19 19 0 01-.16-3.45A16.28 16.28 0 01217.47 395.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8bed3",
    d: "M275.32,241.49a422,422,0,0,0-24.47,36c-2.46,4.09-5.4,9.14-5.88,16.23-.65,9.75,3.89,17.47,5.41,20,3.31,5.49,4.61,4.58,15.06,16.47,7.17,8.15,8.54,10.84,9.41,13.18,1.48,3.92,1.56,7.77,1.65,15.29.14,11.17-.94,13.3-.47,23.3.25,5.36.84,10.68,4,16,1.25,2.1,3.26,5.39,6.12,5.41,3.18,0,5.41-4,5.65-4.47,2.35-4.4-.12-7.27-.24-15.06-.1-6.45,1.49-11.49,3.06-16.47,1.73-5.5,2.79-6.27,4.7-11.3,1.72-4.5,4.77-12.48,4.24-20.94-.81-12.93-9.4-17.76-6.35-25.41,1.43-3.59,4.43-5.31,6.35-6.59,6.78-4.51,15.59-13.84,23.53-35.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M313.82 293.27c1.3-2 2.56-4.06 3.74-6.14s2.31-4.17 3.38-6.31 2.11-4.29 3.13-6.45l3-6.53c-.32 1.16-.69 2.3-1.07 3.45s-.81 2.26-1.24 3.39c-.87 2.24-1.87 4.44-2.95 6.59a62.94 62.94 0 01-3.62 6.27A47 47 0 01313.82 293.27zM275.32 241.49c-6 8.11-11.79 16.38-17.26 24.86-1.36 2.12-2.71 4.25-4 6.39l-2 3.23-1 1.62-.88 1.68c-.57 1.12-1.2 2.21-1.73 3.33s-1 2.26-1.49 3.42-.8 2.35-1.15 3.55-.57 2.43-.82 3.68a19.77 19.77 0 011.11-7.54 21.19 21.19 0 011.51-3.53 30.88 30.88 0 012-3.28l1.06-1.56 1-1.62 2-3.21q2-3.19 4.11-6.36Q266.1 253.51 275.32 241.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffccd8",
    d: "M292.5,391.94c-5.18,4-10.69,3-14.67,1.25A25.38,25.38,0,0,0,280,398c1.25,2.1,3.26,5.39,6.12,5.41,3.18,0,5.41-4,5.64-4.47C293.09,396.48,292.92,394.52,292.5,391.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M283.5 394.71c.1 1.39.06 2.68.08 4 0 .65 0 1.29.07 1.94s.12 1.29.2 2a5 5 0 01-1-1.85 9 9 0 01-.3-2.06 10.07 10.07 0 01.22-2.06A6.55 6.55 0 01283.5 394.71zM288.8 394c-.15 1.56-.39 3-.57 4.51-.11.74-.17 1.48-.25 2.22s-.11 1.5-.21 2.29a8.93 8.93 0 01-.53-4.63 11.9 11.9 0 01.53-2.29A8.19 8.19 0 01288.8 394z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.94,
    height: 6,
    x: 421.97,
    y: 325.02,
    fill: "#fda01f"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63717c",
    d: "M305.32,290.54a45.69,45.69,0,0,0,2.73-3.81c.86-1.3,1.69-2.62,2.44-4a84.31,84.31,0,0,0,4.12-8.37c.33-.7.59-1.44.88-2.16s.58-1.44.82-2.18l.79-2.2.7-2.22c.94-3,1.63-6,2.35-9.08-.18,1.56-.36,3.12-.61,4.67s-.58,3.1-1,4.61a60.46,60.46,0,0,1-3,9,57.9,57.9,0,0,1-4.39,8.36A40.48,40.48,0,0,1,305.32,290.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M466.21,239c.55,2.62.91,5.25,1.2,7.89s.49,5.27.65,7.92.22,5.29.21,7.94a79,79,0,0,1-.36,8c-.55-2.62-.91-5.25-1.2-7.89s-.49-5.27-.65-7.92-.22-5.29-.2-7.94A79,79,0,0,1,466.21,239Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M482.92 254.05c-2.62.55-5.25.91-7.89 1.2s-5.27.49-7.92.65-5.29.22-7.94.21a79 79 0 01-8-.36c2.62-.55 5.25-.91 7.89-1.2s5.27-.49 7.92-.65 5.29-.22 7.94-.2A79 79 0 01482.92 254.05zM487.14 258.48a36.56 36.56 0 011.06 5.3c.24 1.77.42 3.55.51 5.33s.12 3.56.07 5.35a36.47 36.47 0 01-.49 5.38 36.6 36.6 0 01-1.07-5.3c-.24-1.77-.42-3.55-.51-5.33s-.11-3.56-.06-5.35A36.35 36.35 0 01487.14 258.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M498.39 268.58a36.33 36.33 0 01-5.3 1.07c-1.77.24-3.54.41-5.32.51s-3.57.11-5.36.07a36.62 36.62 0 01-5.38-.5 36.56 36.56 0 015.3-1.06c1.77-.24 3.55-.42 5.33-.51s3.56-.11 5.35-.06A37.73 37.73 0 01498.39 268.58zM192.71 19.84c.55 2.62.91 5.25 1.2 7.89s.49 5.28.65 7.92.22 5.29.21 7.94-.08 5.31-.35 8a78.74 78.74 0 01-1.21-7.89c-.3-2.63-.49-5.27-.65-7.91s-.22-5.29-.2-7.95A79 79 0 01192.71 19.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M209.42 34.85c-2.62.55-5.25.91-7.89 1.2s-5.27.49-7.91.65-5.29.22-8 .21-5.3-.08-8-.35a78.74 78.74 0 017.89-1.21c2.64-.3 5.28-.49 7.92-.65s5.29-.22 7.94-.2A78.83 78.83 0 01209.42 34.85zM213.64 39.28a36.56 36.56 0 011.06 5.3c.24 1.77.42 3.55.51 5.33s.12 3.56.07 5.35a36.35 36.35 0 01-.49 5.38 36.6 36.6 0 01-1.07-5.3c-.24-1.77-.41-3.55-.5-5.33s-.12-3.56-.07-5.35A36.47 36.47 0 01213.64 39.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M224.89 49.39a37.53 37.53 0 01-5.29 1.06c-1.78.24-3.55.41-5.33.51s-3.57.12-5.35.07a36.35 36.35 0 01-5.38-.49 34.93 34.93 0 015.29-1.07c1.77-.24 3.55-.42 5.33-.51s3.56-.11 5.35-.06A36.35 36.35 0 01224.89 49.39zM27.05 365.89c.55 2.62.91 5.25 1.2 7.89s.49 5.27.65 7.91.22 5.29.21 7.95-.08 5.3-.35 8a79.18 79.18 0 01-1.21-7.89c-.3-2.64-.49-5.28-.65-7.92s-.22-5.29-.2-7.94A78.83 78.83 0 0127.05 365.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M43.76 380.89a78.74 78.74 0 01-7.89 1.21c-2.63.3-5.27.48-7.91.65s-5.29.22-7.95.2a79 79 0 01-8-.35 78.74 78.74 0 017.89-1.21c2.63-.3 5.28-.48 7.92-.64s5.29-.22 7.94-.21S41.1 380.62 43.76 380.89zM48 385.33a36.29 36.29 0 011.06 5.3c.25 1.77.42 3.54.51 5.32s.12 3.57.07 5.35a36.35 36.35 0 01-.49 5.38 36.2 36.2 0 01-1.07-5.29c-.24-1.77-.41-3.55-.5-5.33s-.12-3.56-.07-5.35A36.35 36.35 0 0148 385.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#439916",
    d: "M59.23,395.43a37.57,37.57,0,0,1-5.29,1.07c-1.78.24-3.55.41-5.33.5s-3.57.12-5.35.07a36.35,36.35,0,0,1-5.38-.49,37.57,37.57,0,0,1,5.29-1.07c1.78-.24,3.55-.41,5.33-.5s3.56-.12,5.35-.07A36.35,36.35,0,0,1,59.23,395.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.32,
    cy: 88.74,
    r: 62.35,
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.32,
    cy: 88.74,
    r: 54,
    fill: "#c1e3f7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M399.32 34.76a11.66 11.66 0 01.5 3.63 11.55 11.55 0 01-.5 3.62 13.39 13.39 0 010-7.25zM399.32 135.48a13.39 13.39 0 010 7.25 13.39 13.39 0 010-7.25zM453.31 88.75a13.39 13.39 0 01-7.25 0 13.39 13.39 0 017.25 0zM352.59 88.75a13.39 13.39 0 01-7.25 0 13.39 13.39 0 017.25 0zM444.92 117.66a12.36 12.36 0 01-3.34-1.52 11.79 11.79 0 01-2.79-2.37 13.41 13.41 0 016.13 3.89zM359.86 63.72a12.3 12.3 0 01-3.33-1.52 11.65 11.65 0 01-2.8-2.37 13.41 13.41 0 016.13 3.89zM427.28 134.93a12.16 12.16 0 01-2.3-2.84 11.65 11.65 0 01-1.45-3.37 13.52 13.52 0 013.75 6.21zM375.12 48.77a12.16 12.16 0 01-2.3-2.84 12 12 0 01-1.46-3.37 11.81 11.81 0 012.31 2.85A12 12 0 01375.12 48.77zM370.41 134.34a12.3 12.3 0 011.52-3.33 11.65 11.65 0 012.37-2.8 13.41 13.41 0 01-3.89 6.13zM424.35 49.28A12 12 0 01425.87 46a11.84 11.84 0 012.37-2.8 13.27 13.27 0 01-3.89 6.13zM353.14 116.71A12 12 0 01356 114.4a12.23 12.23 0 013.37-1.45 13.65 13.65 0 01-6.21 3.76zM439.3 64.54a12.16 12.16 0 012.84-2.3 11.65 11.65 0 013.37-1.45 12 12 0 01-2.85 2.3A11.48 11.48 0 01439.3 64.54zM398.46 89.24L382.7 59.83l17.49 28.41a1 1 0 11-1.7 1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M398.9,87.83l24.26-10.37L399.75,89.64a1,1,0,1,1-.92-1.77Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.32,
    cy: 88.74,
    r: 3.74,
    fill: "#0850ec"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    x2: 512.56,
    y1: 495.78,
    y2: 495.78,
    fill: "none",
    stroke: "#545454",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.3817ba7145479c79b3845cf48eb5e229.svg";
export { ForwardRef as ReactComponent };